import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { CheckboxIcon } from '../../CheckboxIcon';
import styles from './Legend.ChecklistItem.scss';
export var DEFAULT_BACKGROUND_COLOR = '#ffffff';
export var DEFAULT_FADE_COLOR = 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 80%)';
export var TRANSPARENT = "transparent";
/**
 * NOTE: The Legend.ChecklistItem component renders a list item for the Legend. By default the
 * background color is set to DEFAULT_BACKGROUND_COLOR and on hover the background
 * is changed to the color specified by the `hoverColor` prop. The fade color
 * is used for IE to fade out text instead of using '...' to indicate there's
 * more content available. This is because -webkit-line-clamp is not supported
 * in IE to show an ellipsis on the second line of content. By default the fade
 * color is a gradient and on hover is changed to transparent so when a lengend
 * item is hovered the fade doesn't stand out.
 */

export var LegendChecklistItem = function LegendChecklistItem(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      highlighted = _useState2[0],
      setHighlighted = _useState2[1];

  var isHighlighted = props.highlighted || highlighted;

  var onMouseEnter = function onMouseEnter() {
    setHighlighted(true);

    if (props.onMouseEnter) {
      props.onMouseEnter();
    }
  };

  var onMouseLeave = function onMouseLeave() {
    setHighlighted(false);

    if (props.onMouseLeave) {
      props.onMouseLeave();
    }
  };

  return React.createElement("li", {
    id: props.id,
    className: styles.checklistItemContainer,
    "data-test": props.dataTest,
    onClick: props.onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    role: "option",
    "aria-label": props.ariaLabel,
    "aria-selected": props.selected ? 'true' : 'false',
    tabIndex: -1,
    style: {
      backgroundColor: isHighlighted ? props.hoverColor : DEFAULT_BACKGROUND_COLOR
    }
  }, React.createElement("div", {
    className: styles.checkboxContainer,
    "data-test": "legend-checklist-checkbox-".concat(props.selected ? 'checked' : 'unchecked')
  }, React.createElement(CheckboxIcon, {
    className: styles.checkboxIndicator,
    checked: props.selected,
    color: props.checkboxColor ? props.checkboxColor : null
  })), React.createElement("div", {
    className: styles.legendText
  }, props.label), React.createElement("div", {
    className: styles.ellipsis,
    "data-test": "fade-overlay",
    style: {
      backgroundColor: isHighlighted ? TRANSPARENT : DEFAULT_FADE_COLOR
    }
  }));
};